<template>
  <tabs>
    <tab :default="true" icon="/img/editor/marker.png" name="Gegevens" id="location">
      <h1>
        Gegevens
      </h1>

      <h2>Datum</h2>
      <flat-pickr
          dateFormat="d-m-Y"
          :config="config"
          @on-change="onChange"
          v-model="$root.print.date"/>

      <p class="text-white">Op basis van deze datum wordt het sterrenbeeld geselecteerd.</p>
    </tab>
    <tab icon="/img/editor/picture.png" name="Stijlen" id="style">
      <h1>
        Stijlen
      </h1>
      <div class="grid grid-cols-2 gap-2">
        <div v-for="[key, zodiacStyle] in Object.entries($root.zodiacStyles)"
             :key="key"
             v-bind:class="[ zodiacStyle.slug === $root.print.design ? 'ring-4 ring-white' : '' ]"
             v-on:click="$root.print.design = zodiacStyle.slug"
             class="selectable"
        >
          {{ zodiacStyle.name }}
        </div>
      </div>
      <h2>Kleur</h2>
      <div class="grid grid-cols-3 gap-2">
        <div v-for="[key, color] in Object.entries($root.colors)"
             :key="key"
             v-bind:class="[ key === $root.print.color ? 'ring-4 ring-white' + ' ' : '' ] + color.color + ' ' + color.signColor"
             v-on:click="$root.print.color = key"

             class="selectable"
        >
          {{ color.name }}
        </div>
      </div>
<!--      <div class="grid grid-cols-3">-->
<!--        <div v-for="[key, zodiacSign] in Object.entries($root.zodiacSigns)"-->
<!--             :key="key"-->
<!--             v-bind:class="[ key === $root.print.zodiac ? 'active' : '' ]"-->
<!--             v-on:click="$root.print.zodiac = key"-->
<!--             class="selectable"-->
<!--        >-->
<!--          <img class="w-10 h-10 p-2" :src="`/img/editor/zodiac/zodiac-2/${key}.svg`">-->
<!--          {{ zodiacSign.nl }}-->
<!--          <span class="text-xs">-->
<!--            {{ $root.zodiacDates[key].from }}/{{ $root.zodiacDates[key].to }}-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->
    </tab>

    <tab icon="/img/editor/text.png" name="Tekst" id="texts" class="tabcontent">
      <h1>
        Teksten
      </h1>

      <label class="text-white">Titel</label>
      <input type="text" class="py-2 mb-2 mt-0" v-model="$root.print.title"/>
      <label class="text-white">Subtitel <small>(hiermee pas je niét de datum aan)</small></label>
      <input type="text" class="py-2 mb-2 mt-0" v-model="$root.print.subtitle"/>
      <label class="text-white">Slogan</label>
      <input type="text" class="py-2 mb-2 mt-0" v-model="$root.print.tagline"/>
    </tab>
    <tab icon="/img/editor/shopping-cart.png" name="Afronden" id="finish" class="tabcontent"
         :is-last="true">
      <h1>
        Materiaal
        <a v-on:click="$root.showMaterialModal = true"
           class="cursor-pointer"
           style="text-align: center; margin-top: -3px; background: white; color: green; border-radius: 50%; font-size: 15px; width: 30px; height: 30px; display: inline-block; line-height: 30px;"
           title="Materialen">?</a>
      </h1>

      <div id="type" class="grid grid-cols-2 gap-1">
        <editor-button
            v-for="item in $root.materials"
            :key="item.material"
            :active="item.material === $root.print.material"
            v-on:click.native="$root.print.material = item.material"
        >
          <span class="title" style="font-weight: bold;">{{ item.name }}</span>
        </editor-button>
      </div>
      <div id="sizes" class="card-panel collection no-padding space-y-1">
        <h2>Kies je formaat</h2>

        <div class="grid grid-cols-1 gap-1">
          <editor-button
              v-for="sizeOption in $root.sizes"
              v-if="sizeOption.material === $root.print.material"
              :key="sizeOption.name + sizeOption.name"
              :active="$root.print.size === sizeOption.name"
              v-on:click.native="$root.print.size = sizeOption.name"
          >
            <span class="title" style="font-weight: bold;">
              <span v-if="sizeOption.material !== 'puzzle'">{{ sizeOption.name }}</span>
              <span v-else>{{ sizeOption.displayName }}</span>

              <small v-if="sizeOption.material === 'poster'">{{
                  sizeOption.width + ' &times; ' + sizeOption.height + 'mm'
                }}</small>
              <small v-else>
                <span v-if="sizeOption.material !== 'puzzle'">
                  cm
                </span>
                <span v-else>
                  {{ sizeOption.name }} stukjes
                </span>
              </small>
            </span>
            <span class="secondary-content">&euro; {{ sizeOption.price }}</span>
          </editor-button>
        </div>
      </div>
    </tab>
  </tabs>
</template>

<script>
import Tabs from "../Tabs";
import Tab from "../Tab";
import LocationAutoComplete from "../LocationAutoComplete";
import EditorButton from "../EditorButton";
import Checkmark from "../Checkmark";

import flatPickr from 'vue-flatpickr-component';
import {Dutch} from 'flatpickr/dist/l10n/nl.js';

export default {
  name: "ZodiacTabs",

  components: {
    Checkmark,
    EditorButton,
    LocationAutoComplete,
    Tabs,
    Tab,

    flatPickr,
  },

  data() {
    return {
      config: {
        altFormat: 'd-m-Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Dutch, // locale for this instance only
      },
    }
  },

  methods: {
    onChange(event){
      console.log('zodiacChange', event)
      const date = new Date(event);

      this.$root.print.subtitle = date.toLocaleDateString('nl-nl', {year: 'numeric', month: '2-digit', day: '2-digit'});

      // thanks; https://medium.com/@Saf_Bes/get-the-zodiac-sign-for-a-date-in-javascript-797305d75869
      const signs = Object.keys(this.$root.zodiacDates)
      const sign = Number(new Intl.DateTimeFormat('fr-TN-u-ca-persian', {month: 'numeric'}).format(date)) - 1;

      console.log(signs[sign]);

      this.$root.print.zodiac = signs[sign]
      this.$root.print.tagline = this.$root.zodiacSigns[signs[sign]].nl
    }
  }
}
</script>

<style scoped>
@import '~flatpickr/dist/flatpickr.css';

input:checked + svg {
  display: block;
}
</style>